// extracted by mini-css-extract-plugin
export default {"firstHeader":"Header_firstHeader__PdHJf","secondHeader":"Header_secondHeader__VJvly","thirdHeader":"Header_thirdHeader__zvjCQ","nav":"Header_nav__K0Qy7","logo":"Header_logo__9YFPc"};